import { store } from 'quasar/wrappers'
import { createStore } from 'vuex'
import auth from './auth'
import user from './user'
import requests from './request'
import orders from './orders'
import activities from './activities'
import companies from './companies'
import updates from './updates'
import orderStatus from './orders-status'
import devices from './devices'
import evidences from './evidences'
import evidenceTypes from './evidence-types'
import serviceTypes from './service-types'
import carTypes from './car-types'
import zipCodes from './zip-codes'
import comments from './comments'
import quotes from './quotes'
import dashboard from './dashboard'
import notifications from './notifications'
import cars from './cars'
import appPair from './app-pair'
import userPreferences from './user-preferences'
import measurementUnits from './measurement-units'
import origins from './origins'
import unitRequests from './unit-requests'

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store(function (/* { ssrContext } */) {
  const Store = createStore({
    modules: {
      // example
      auth,
      user,
      orders,
      requests,
      activities,
      companies,
      updates,
      orderStatus,
      evidences,
      evidenceTypes,
      serviceTypes,
      devices,
      zipCodes,
      carTypes,
      comments,
      quotes,
      dashboard,
      notifications,
      cars,
      'app-pair': appPair,
      'user-preferences': userPreferences,
      'measurement-units': measurementUnits,
      origins,
      'unit-requests': unitRequests
    },

    // enable strict mode (adds overhead!)
    // for dev mode and --debug builds only
    strict: process.env.DEBUGGING
  })

  return Store
})
